import routes from './routes'
import main from './main'
import validation from './validation'
// Modules
import ark_import from './modules/ark_import'
import user_management from './modules/user_management'
import correction_invoice from './modules/correction_invoice'

export default {
    en: {
        main: main.en,
        validation: validation.en,
        routes: routes.en,
        ark_import: ark_import.en,
        user_management: user_management.en,
        correction_invoice:correction_invoice.en
    },
    et: {
        main: main.et,
        validation: validation.et,
        routes: routes.et,
        ark_import: ark_import.et,
        user_management: user_management.et,
        correction_invoice: correction_invoice.et
    }
  }